import { FC, PropsWithChildren, createContext, useCallback, useContext, useState } from 'react';

type AccordionContextType = {
    openedState: Set<string>;
    toggleOpenedState: (id: string) => void;
};

const AccordionContext = createContext<AccordionContextType>({
    openedState: new Set(),
    toggleOpenedState: () => {},
});

export const useAccordion = () => useContext(AccordionContext);

const AccordionGroup: FC<PropsWithChildren> = ({ children }) => {
    const [openedState, updateOpenedState] = useState<Set<string>>(new Set());

    const toggleOpenedState = useCallback((id: string) => {
        updateOpenedState((prevState) => {
            const newState = new Set(prevState);
            if (newState.has(id)) {
                newState.delete(id);
            } else {
                newState.add(id);
            }
            return newState;
        });
    }, []);

    return (
        <AccordionContext.Provider value={{ openedState, toggleOpenedState }}>
            {children}
        </AccordionContext.Provider>
    );
};

export default AccordionGroup;
